import React from 'react';
import { Menu, HelpCircle, Sparkles } from 'lucide-react';
interface TopBarProps {
  isDrawerOpen: boolean;
  onToggleDrawer: () => void;
  onToggleHelp?: () => void;
  onToggleChat?: () => void;
  helpOpen?: boolean;
  chatOpen?: boolean;
}
export function TopBar({
  isDrawerOpen,
  onToggleDrawer,
  onToggleHelp,
  onToggleChat,
  helpOpen,
  chatOpen
}: TopBarProps) {
  return <header className="fixed top-0 left-0 right-0 h-14 bg-[#141418] z-30" data-id="element-2132">
      <div className="h-full px-6 flex items-center justify-between" data-id="element-2133">
        {!isDrawerOpen ? <button onClick={onToggleDrawer} className="w-10 h-10 flex items-center justify-center hover:bg-white/5 rounded-lg transition-colors" aria-label="Open menu" data-id="element-2134">
            <Menu size={20} className="text-[#e8e4df]/70" strokeWidth={1.5} data-id="element-2135" />
          </button> : <div className="w-10" data-id="element-2136" />}

        <h1 className="absolute left-1/2 -translate-x-1/2 text-[#e8e4df] font-heading font-medium tracking-[0.08em] text-base" data-id="element-2137">
          zenbot
        </h1>

        <div className="flex items-center gap-1" data-id="element-2138">
          {onToggleHelp && <button onClick={onToggleHelp} className={`w-10 h-10 flex items-center justify-center hover:bg-white/5 rounded-lg transition-colors ${helpOpen ? 'text-[#4a9a9a]' : 'text-[#8a8680]/40'}`} aria-label="Toggle help" aria-pressed={!!helpOpen} data-id="element-2139">
              <HelpCircle size={16} strokeWidth={1.5} data-id="element-2140" />
            </button>}
          {onToggleChat && <button onClick={onToggleChat} className={`w-10 h-10 flex items-center justify-center hover:bg-white/5 rounded-lg transition-colors ${chatOpen ? 'text-[#4a9a9a]' : 'text-[#8a8680]/40'}`} aria-label="Toggle AI chat" aria-pressed={!!chatOpen} data-id="element-2141">
              <Sparkles size={16} strokeWidth={1.5} data-id="element-2142" />
            </button>}
          {!onToggleHelp && !onToggleChat && <div className="w-10" data-id="element-2143" />}
        </div>
      </div>
    </header>;
}